import React from 'react'
import './about.css'
import Me from '../../assets/me.gif'
import {FaAward} from 'react-icons/fa'

const About = () => {
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={Me} alt="About"/>
          </div>
        </div>
        <div className='about__content'>
           <p>
            Front-end web developer with 2+ years of experience in ReactJs. Dedicated to bringing both 
            technical and visual aspects of digital products to life. 
          </p>
          <p> 
            Enjoys brainstorming with a team to develop 
            creative solutions to complex design and development challenges. In my free time, you can find me 
            exploring the web development trends, and occasionally indulging in a little Netflix and CSS.</p>
          <div className='about__cards'>
            <article className='about__card'>
              <FaAward className='about__icon' />
              <h5>Experience</h5>
              <ul>
                <li><small>2+ Years Working</small></li>
                <li><small>ReactJs</small></li>
                <li><small>AngularJs</small></li>
              </ul>
            </article>
            <article className='about__card'>
              <FaAward className='about__icon' />
              <h5>Projects</h5>
              <ul>
                <li><small>Analytics Dashboards</small></li>
                <li><small>Admin Dashboard</small></li>
                <li><small>SPA, Kiosks</small></li>
                <li><small>Auto-Tweet App</small></li>
              </ul>
            </article>
            <article className='about__card'>
              <FaAward className='about__icon' />
              <h5>Academic</h5>
              <small>Master of Computer Science</small>
            </article>
          </div>
          <p></p>
          <h4>Currently Working on: </h4>
          <p>Improving my skill in understanding on React, cross platform applications, and building my own APIs.</p>
          <a href='#contact'>Reach Me</a>
        </div>
      </div>
    </section>
  )
}

export default About